import { render, staticRenderFns } from "./DocumentsAddDlg.vue?vue&type=template&id=57fde22c&scoped=true"
import script from "./DocumentsAddDlg.ts?vue&type=script&lang=ts&external"
export * from "./DocumentsAddDlg.ts?vue&type=script&lang=ts&external"
import style0 from "./DocumentsAddDlg.scss?vue&type=style&index=0&id=57fde22c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fde22c",
  null
  
)

export default component.exports